import React from 'react'
import SimpleCard from '../../components/templates/SimpleCard'

const RekapXLS = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Rekap Transaksi XLS</h1>
        <p className="page-subtitle">Export rekap transaksi ke format Excel</p>
      </div>
      
      <SimpleCard>
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <h3>Rekap Transaksi XLS</h3>
          <p>Fitur export rekap transaksi ke Excel akan diimplementasikan di sini</p>
        </div>
      </SimpleCard>
    </div>
  )
}

export default RekapXLS